@if (notificationsLoading()) {
  <app-loading></app-loading>
}

@if (!notificationsLoading()) {
  <div class="notifications">
    <h5>
      <fa-icon [icon]="['fas', 'flag']"></fa-icon>
      {{ "notifications.title.notifications-center" | translate }}
    </h5>
    @if (notifications().length > 0) {
      @for (notification of notifications(); track notification) {
        <app-notification [notification]="notification"></app-notification>
      }
    } @else {
      <p class="no-notifications">
        {{ "notifications.message.no-notifications" | translate }}
      </p>
    }
  </div>
}
